import Point from './point'

const PointList = ({ points }) => {
  const base = 'relative flex flex-col gap-y-[5px] lg:gap-y-[11px]'

  return (
    <div className={base}>
      {points.map((point, id) => (
        <Point key={id} text={point.text} />
      ))}
    </div>
  )
}

export default PointList
